/**
 * Ana sayfa urun grid: en cok satan siralama + 4 satir limiti.
 */
function getColumnsPerRow(host) {
  const desktop = Number(host.dataset.colsDesktop) || 5;
  if (window.matchMedia('(min-width: 990px)').matches) return desktop;
  if (window.matchMedia('(min-width: 750px)').matches) return 3;
  return 2;
}

function getMaxVisible(host) {
  // "Tumunu goster" modu: hicbir urunu gizleme, hepsini goster.
  if (host.dataset.showAll === 'true') {
    return host.querySelectorAll('.trendyol-grid__item').length;
  }
  // Mobilde 24 urunu dogrudan goster (devamini gor gerekmeden)
  if (!window.matchMedia('(min-width: 750px)').matches) {
    return 24;
  }
  const rows = Number(host.dataset.rows) || 4;
  return rows * getColumnsPerRow(host);
}

function applyRowLimit(host) {
  const max = getMaxVisible(host);
  const items = [...host.querySelectorAll('.trendyol-grid__item')];

  items.forEach((item, index) => {
    item.hidden = index >= max;
  });

  const footer = host.closest('.trendyol-grid')?.querySelector('[data-grid-footer]');
  if (footer) footer.hidden = false;
}

function reorderItems(host, handlesInOrder) {
  const grid = host.querySelector('[data-trendyol-grid-products]');
  if (!grid) return;

  const byHandle = new Map();
  for (const item of grid.querySelectorAll('.trendyol-grid__item')) {
    const handle = item.dataset.productHandle;
    if (handle) byHandle.set(handle, item);
  }

  const ordered = [];
  const used = new Set();

  for (const handle of handlesInOrder) {
    const item = byHandle.get(handle);
    if (item && !used.has(handle)) {
      ordered.push(item);
      used.add(handle);
    }
  }

  for (const item of grid.querySelectorAll('.trendyol-grid__item')) {
    const handle = item.dataset.productHandle;
    if (!used.has(handle)) ordered.push(item);
  }

  ordered.forEach((item) => grid.appendChild(item));
}

async function sortBestSelling(host) {
  const pool = Number(host.dataset.productPool) || 48;
  const collectionHandle = host.dataset.collectionHandle;

  try {
    let handles = [];
    if (collectionHandle === 'all') {
      const res = await fetch(`/products.json?limit=${pool}`);
      if (res.ok) {
        const data = await res.json();
        handles = (data.products || []).map((p) => p.handle);
      }
    } else if (collectionHandle) {
      const res = await fetch(`/collections/${collectionHandle}/products.json?limit=${pool}&sort_by=best-selling`);
      if (res.ok) {
        const data = await res.json();
        handles = (data.products || []).map((p) => p.handle);
      }
    }

    if (handles.length >= 2) {
      reorderItems(host, handles);
      return;
    }
  } catch {
    /* fall through */
  }

  sortCatalog(host);
}

function sortCatalog(host) {
  const grid = host.querySelector('[data-trendyol-grid-products]');
  if (!grid) return;

  const items = [...grid.querySelectorAll('.trendyol-grid__item')];
  if (items.length < 2) return;

  items.sort((a, b) => {
    const sortDiff = Number(b.dataset.catalogSort || 0) - Number(a.dataset.catalogSort || 0);
    if (sortDiff !== 0) return sortDiff;
    return Number(b.dataset.reviewCount || 0) - Number(a.dataset.reviewCount || 0);
  });

  items.forEach((item) => grid.appendChild(item));
}

async function initGrid(host) {
  const sort = host.dataset.sort || 'manual';

  if (sort === 'best-selling') {
    await sortBestSelling(host);
  } else if (sort === 'catalog') {
    sortCatalog(host);
  }

  applyRowLimit(host);
  host.dataset.gridReady = 'true';
}

function initAll() {
  document.querySelectorAll('[data-home-product-grid]').forEach((host) => {
    if (host.dataset.gridReady === 'true') return;
    initGrid(host);
  });
}

let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.querySelectorAll('[data-home-product-grid][data-grid-ready="true"]').forEach(applyRowLimit);
  }, 120);
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll, { once: true });
} else {
  initAll();
}

document.addEventListener('shopify:section:load', initAll);
